let countryList = document.getElementById('countries-list');
let countryListDataset = document.getElementById('shipping-countries-list');
let currentFocus = -1;

countryList.onfocus = function () {
  countryListDataset.style.display = 'block';
};

for (let option of countryListDataset.options) {
  option.onclick = function (e) {
    countryList.value = option.value;
    countryListDataset.style.display = 'none';
  };
}

countryList.oninput = function () {
  currentFocus = -1;
  var text = countryList.value.toUpperCase();
  for (let option of countryListDataset.options) {
    if (option.value.toUpperCase().indexOf(text) > -1) {
      option.style.display = 'flex';
    } else {
      option.style.display = 'none';
    }
  }
};

countryList.onkeydown = function (e) {
  if (e.keyCode == 40) {
    currentFocus++;
    addActive(countryListDataset.options);
  } else if (e.keyCode == 38) {
    currentFocus--;
    addActive(countryListDataset.options);
  } else if (e.keyCode == 13) {
    e.preventDefault();
    if (currentFocus > -1) {
      if (countryListDataset.options)
        countryListDataset.options[currentFocus].click();
    }
  }
};

function addActive(x) {
  if (!x) return false;
  removeActive(x);
  if (currentFocus >= x.length) currentFocus = 0;
  if (currentFocus < 0) currentFocus = x.length - 1;
  x[currentFocus].classList.add('active');
}
function removeActive(x) {
  for (var i = 0; i < x.length; i++) {
    x[i].classList.remove('active');
  }
}

document.addEventListener('click', (e) => {
  if (e.target.id == countryList.id) {
    return;
  }
  if (e.target.id == countryListDataset.id) {
    return;
  }
  countryListDataset.style.display = 'none';
});
